// Lista canônica de recursos, exibida na mesma ordem em todos os planos.
// Cada plano marca cada item como incluído (check) ou não incluído (X), para que
// a comparação entre os cards fique imediata.
const FEATURE_ORDER = [
    'patients',
    'evaluations',
    'exams',
    'riskMatrix',
    'logo',
    'aiReports',
    'acia',
    'devices',
    'video',
];

const FEATURE_LABELS = {
    patients: () => 'Gestão completa de pacientes',
    evaluations: () => 'Avaliações ilimitadas',
    exams: () => 'Upload de exames complementares',
    riskMatrix: () => 'Matriz de risco',
    logo: () => 'Sua logo no relatório',
    aiReports: (value) => (value ? `${value} relatórios com Inteligência Artificial` : 'Relatórios com Inteligência Artificial'),
    acia: (value) => (value ? `${value} análises ACIA` : 'Análises ACIA'),
    devices: (value) => (value ? `${value} dispositivos conectados simultaneamente` : 'Dispositivos conectados simultaneamente'),
    video: () => 'Upload de vídeo na avaliação',
};

export const PLANS = [
    {
        id: 'basico',
        rank: 1,
        name: 'Plano Básico',
        price: 39.90,
        priceLabel: 'R$ 39,90',
        interval: 'mês',
        ctaLabel: 'Assinar Básico',
        maxDevices: 2,
        capabilities: {
            patients: true,
            evaluations: true,
            exams: true,
            riskMatrix: true,
            logo: true,
            aiReports: 10,
            acia: 5,
            devices: 2,
            video: false,
        },
    },
    {
        id: 'standard',
        rank: 2,
        name: 'Plano Standard',
        price: 59.90,
        priceLabel: 'R$ 59,90',
        interval: 'mês',
        ctaLabel: 'Assinar Standard',
        highlight: true,
        badge: 'Mais popular',
        maxDevices: 5,
        highlightKeys: ['aiReports', 'acia', 'devices'],
        capabilities: {
            patients: true,
            evaluations: true,
            exams: true,
            riskMatrix: true,
            logo: true,
            aiReports: 30,
            acia: 20,
            devices: 5,
            video: false,
        },
    },
    {
        id: 'premium',
        rank: 3,
        name: 'Plano Premium',
        price: 79.90,
        priceLabel: 'R$ 79,90',
        interval: 'mês',
        ctaLabel: 'Assinar Premium',
        highlight: true,
        badge: 'Vídeos incluídos',
        maxDevices: 15,
        highlightKeys: ['aiReports', 'acia', 'devices', 'video'],
        capabilities: {
            patients: true,
            evaluations: true,
            exams: true,
            riskMatrix: true,
            logo: true,
            aiReports: 70,
            acia: 40,
            devices: 15,
            video: true,
        },
    },
];

// Resolve a lista canônica para um plano: mesmo número de itens em todos os cards,
// cada um com `included` (check ou X) e o valor do próprio plano quando numérico.
export function getPlanFeatures(plan) {
    const capabilities = (plan && plan.capabilities) || {};
    const highlightKeys = (plan && plan.highlightKeys) || [];

    return FEATURE_ORDER.map((key) => {
        const value = capabilities[key];
        const included = Boolean(value);
        return {
            key,
            label: FEATURE_LABELS[key](included ? value : null),
            included,
            highlight: included && highlightKeys.includes(key),
        };
    });
}

export function getDefaultPlan() {
    return PLANS[0];
}
